import React, {Component} from 'react';
import RemoveLineup from './components/remove-lineup';
import CheckLineup from './components/check-lineup';
import {Factory as LineupPlayersFactory} from './components/desktop/lineup-players/factory';
import {Factory as LineupDetailsFactory} from './components/desktop/lineup-details/factory';
import {connect} from 'react-redux';
import LineupsComparison from 'components/organisms/late-swap/components/lineups-comparison';
import PopupOpener from 'components/atoms/popup-opener';
import {createViewComponentLineupId} from 'helpers/lineup-helper';

class Lineup extends Component {
    getLineupsComparisonButton() {
        const {sportConfig, lineupId} = this.props;

        if (!sportConfig.isModeLateswap()) {
            return null;
        }

        return (
            <div className="actions-holder">
                <PopupOpener
                    tooltipText="Compare lineups"
                    className="btn-compare"
                    component={<LineupsComparison lineupId={lineupId} />}
                >
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="not-equal"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                    >
                        <path
                            fill="currentColor"
                            d="M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                        />
                    </svg>
                </PopupOpener>
                <RemoveLineup lineupId={lineupId} className="delete-lineup">
                    <i className="fa fa-trash" />
                </RemoveLineup>
            </div>
        );
    }

    render() {
        const {sportConfig, lineups, lineupId, index} = this.props;

        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const LineupDetails = LineupDetailsFactory.getComponent(sportConfig);
        const LineupPlayers = LineupPlayersFactory.getComponent(sportConfig);

        return (
            <div key={lineupId} id={createViewComponentLineupId(lineupId)} className="lineup-box">
                <div className="lineup-header">
                    {lineup && !sportConfig.isModeLateswap() ? (
                        <label className="checkbox-inline title">
                            <CheckLineup lineupId={lineupId} />
                            <span>L{1 + index}</span>
                        </label>
                    ) : (
                        <span className="title">L{1 + index}</span>
                    )}
                    <LineupDetails lineup={lineup} />
                    {this.getLineupsComparisonButton()}
                </div>
                <LineupPlayers lineupId={lineupId} />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        sportConfig,
    } = state;

    return {
        lineups,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(Lineup);
